import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ValueFirstOnboardingService } from '../../services/value-first-onboarding.service';

@Component({
  selector: 'vf-account-step',
  templateUrl: './account-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VfAccountStep {
  readonly onboarding = inject(ValueFirstOnboardingService);
  readonly password = signal('');
  readonly passwordVisible = signal(false);

  onFirstName(event: Event): void {
    this.onboarding.setName((event.target as HTMLInputElement).value, this.onboarding.draft().lastName);
  }

  onLastName(event: Event): void {
    this.onboarding.setName(this.onboarding.draft().firstName, (event.target as HTMLInputElement).value);
  }

  onPassword(event: Event): void {
    this.password.set((event.target as HTMLInputElement).value);
    this.onboarding.clearError();
  }

  togglePassword(): void {
    this.passwordVisible.update((visible) => !visible);
  }

  submit(event: Event): void {
    event.preventDefault();
    void this.onboarding.submitAccount(this.password());
  }
}
